import { render, staticRenderFns } from "./Slovane.vue?vue&type=template&id=62594d8c&scoped=true&"
import script from "./Slovane.vue?vue&type=script&lang=js&"
export * from "./Slovane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62594d8c",
  null
  
)

export default component.exports